<template>

  <div class="pdf-wrapper" 
       @contextmenu.prevent  
       @dragstart.prevent  
       @selectstart.prevent 
       @keydown.prevent="handleKeyDown" 
  >
  <!-- 添加不可见的反调试元素 -->
<div style="display: none;" aria-hidden="true">
  <div id="anti-debugger"></div>
  <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=" 
       onerror="(() => { if (window.devtools) { window.location.reload(); } })();" 
       alt="">
</div>
    <!-- 改用背景图方式展示，避免直接img标签可保存 -->
    <div class="pdf-image-container" v-if="imageList.length > 0">
      <div 
        v-for="(img, index) in imageList" 
        :key="index" 
        class="pdf-page-container"
        :style="{ backgroundImage: `url(${img})` }"
      >
        <!-- 文字水印覆盖层 -->
        <!-- <div class="watermark-overlay">
          <div class="watermark-text">西宝电子</div>
        </div> -->
      </div>
    </div>
    
    <!-- 错误提示 -->
    <div v-if="error" class="error-tip">{{ error }}</div>
  </div>
</template>

<script>
import RequestUtil from '../utils/request'

export default {
  name: 'PdfShow',
  data() {
    return {
      imageList: [],
      error: '',
      debuggerDetected: false
    }
  },
  created() {
    this.fetchPdf()
    // 监听打印事件
    window.addEventListener('beforeprint', this.handleBeforePrint)
    // 添加反调试
    this.preventDebugger()
  },
  mounted() {
    // 监听F12、开发者工具打开
    this.disableDevTools()
  },
  destroyed() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener('beforeprint', this.handleBeforePrint)
    window.removeEventListener('keydown', this.keydownHandler)
    window.removeEventListener('contextmenu', this.contextmenuHandler)
  },
  methods: {
    fetchPdf() {

      if(this.$route.query.type === "APP"){
        const url = this.$route.query.url
         RequestUtil.get(`/wx/solution/getSolutionInfoListByUrl?url=${url}`)
        .then(response => {
          const url = response.data
          
          // 确保imageList是数组格式
          if (Array.isArray(url)) {
            this.imageList = url
          } else if (url) {
            this.imageList = [url] // 单个图片转为数组
          } else {
            this.error = '未获取到PDF图片数据'
          }
        })
        .catch(error => {
          console.error('获取PDF图片失败:', error)
          this.error = '获取PDF图片失败，请重试'
        })
      }else{
         const chipId = this.$route.query.chipId
      
     RequestUtil.get(`/wx/product/eleChipInfoByChipId?chipId=${chipId}`)
        .then(response => {
          const url = response.data
          
          // 确保imageList是数组格式
          if (Array.isArray(url)) {
            this.imageList = url
          } else if (url) {
            this.imageList = [url] // 单个图片转为数组
          } else {
            this.error = '未获取到PDF图片数据'
          }
        })
        .catch(error => {
          console.error('获取PDF图片失败:', error)
          this.error = '获取PDF图片失败，请重试'
        })
      }

     
      
     
    },
    
    // 综合键盘事件处理
    keydownHandler(e) {
      // 禁止所有功能键组合
      const forbiddenCombos = [
        e.ctrlKey && e.shiftKey && e.key === 'I', // Ctrl+Shift+I
        e.ctrlKey && e.shiftKey && e.key === 'J', // Ctrl+Shift+J
        e.ctrlKey && e.shiftKey && e.key === 'C', // Ctrl+Shift+C
        e.ctrlKey && e.key === 'u', // Ctrl+U 查看源码
        e.ctrlKey && e.key === 's', // Ctrl+S 保存
        e.ctrlKey && e.key === 'p', // Ctrl+P 打印
        e.ctrlKey && e.key === 'w', // Ctrl+W 关闭
        e.ctrlKey && e.key === 'r', // Ctrl+R 刷新
        e.ctrlKey && e.shiftKey && e.key === 'R', // Ctrl+Shift+R 强制刷新
        e.key === 'F12', // F12
        e.key === 'F11', // F11 全屏
        e.key === 'F5', // F5 刷新
        e.key === 'PrintScreen', // 打印屏幕
        (e.altKey && e.key === 'F4') // Alt+F4 关闭窗口
      ]
      
      if (forbiddenCombos.some(Boolean)) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    
    // 右键菜单处理
    contextmenuHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    },
    
    // 禁用开发者工具
    disableDevTools() {
      // 1. 监听键盘事件
      window.addEventListener('keydown', this.keydownHandler)
      
      // 2. 监听右键菜单
      window.addEventListener('contextmenu', this.contextmenuHandler)
      
      // 3. 检查开发者工具打开状态
      this.checkDevTools()
      
      // 4. 监听窗口尺寸变化（检测开发者工具打开）
      let threshold = 160
      let lastTime = Date.now()
      
      const checkDevToolsBySize = () => {
        const widthThreshold = window.outerWidth - window.innerWidth > threshold
        const heightThreshold = window.outerHeight - window.innerHeight > threshold
        const isDevToolsOpen = widthThreshold || heightThreshold
        
        if (isDevToolsOpen && !this.debuggerDetected) {
          this.debuggerDetected = true
          this.handleDevToolsOpened()
        }
        
        // 每秒检查一次
        setTimeout(checkDevToolsBySize, 1000)
      }
      
      checkDevToolsBySize()
      
      // 5. 覆盖console方法
      if (process.env.NODE_ENV === 'production') {
        this.disableConsole()
      }
    },
    
    // 检测并阻止开发者工具
    checkDevTools() {
      // 方法1: 使用debugger循环检测
      const element = new Image()
      Object.defineProperty(element, 'id', {
        get: () => {
          this.handleDevToolsOpened()
        }
      })
      
      setInterval(() => {
        console.debug(element)
        console.clear()
      }, 2000)
      
      // 方法2: 使用性能检测
      setInterval(() => {
        const startTime = performance.now()
        debugger
        const endTime = performance.now()
        
        if (endTime - startTime > 100) {
          this.handleDevToolsOpened()
        }
      }, 3000)
    },
    
    // 开发者工具打开处理
    handleDevToolsOpened() {
      if (this.debuggerDetected) return
      
      this.debuggerDetected = true
      
      // 1. 清除页面内容
      this.imageList = []
      
      // 2. 显示警告
      this.error = '检测到开发者工具，为保护文档安全已关闭查看'
      
      // 3. 重定向或刷新
      setTimeout(() => {
        // 可以选择重定向到空白页
        // this.$router.push('/404')
        // 或者刷新页面
        window.location.reload()
      }, 100)
      
      // 4. 无限debugger干扰
      this.infiniteDebugger()
    },
    
    // 无限debugger干扰
    infiniteDebugger() {
      setInterval(() => {
        const startTime = performance.now()
        debugger
        const endTime = performance.now()
        
        if (endTime - startTime > 50) {
          // 如果debugger被跳过，再次触发
          window.location.reload()
        }
      }, 500)
    },
    
    // 禁用控制台输出
    disableConsole() {
      // 保存原始console
      const originalConsole = {
        log: console.log,
        info: console.info,
        warn: console.warn,
        error: console.error,
        debug: console.debug
      }
      
      // 重写console方法
      console.log = function() {}
      console.info = function() {}
      console.warn = function() {}
      console.error = function() {}
      console.debug = function() {}
      
      // 防止恢复console
      Object.freeze(console)
    },
    
    // 防止调试器附加
    preventDebugger() {
      // 检测是否在调试模式下
      const checkDebugger = () => {
        const startTime = Date.now()
        debugger
        const endTime = Date.now()
        
        if (endTime - startTime > 50) {
          this.handleDevToolsOpened()
        }
      }
      
      setInterval(checkDebugger, 2000)
    },
    
    // 处理打印事件
    handleBeforePrint() {
      // 阻止打印
      alert('本内容禁止打印')
      window.print = function() {
        alert('本内容禁止打印')
        return false
      }
      
      // 触发反打印样式
      document.body.classList.add('prevent-print')
    }
  }
}
</script>


<style scoped>
.pdf-wrapper {
  width: 100%;
  min-height: 100vh;
  user-select: none; /* 禁止文本选择 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  background-color: #282828;
}

/* 精准设置图片宽度为屏幕的71.5%（你当前改为了60%） */
.pdf-image-container {
  width: 60%; /* 固定为屏幕宽度的60% */
  margin: 0 auto;
  padding: 10px;
}

/* 保证图片完整展示，不修改原图样式 */
.pdf-page-container {
  width: 100%;
  height: auto; /* 完全自适应高度 */
  margin: 10px 0;
  /* border: 1px solid #eee; */
  border-radius: 4px;
  /* 核心：contain保证图片完整展示，不裁剪、不拉伸 */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center top;
  /* A4比例适配PDF，保证容器高度匹配图片 */
  aspect-ratio: 1 / 1.414;
  position: relative;
  /* 禁止打印该元素 */
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

/* 水印覆盖层 - 仅覆盖，不影响原图 */
.watermark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 不影响交互 */
  overflow: hidden;
  background-color: transparent;
  /* 让覆盖层本身居中，方便子元素居中 */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 单个居中水印样式（核心修改） */
.watermark-text {
  position: static; /* 取消绝对定位，使用flex居中 */
  width: auto;      /* 取消200%宽高，自适应文字宽度 */
  height: auto;
  font-size: 48px;  /* 适中的字体大小，醒目但不突兀 */
  font-weight: 500;
  color: rgba(0, 0, 0, 0.12); /* 半透明，不干扰原图 */
  transform: rotate(-10deg);   /* 轻微倾斜，更美观 */
  letter-spacing: 8px;         /* 增加字间距，提升质感 */
  /* 取消flex-wrap等多余样式 */
  display: block;
  padding: 0;
  line-height: 1;
}

.watermark-text::before {
  content: "西宝电子";
  display: block;
  margin: 0; /* 取消右侧间距 */
  transform: none;
  white-space: nowrap;
}

/* 禁止打印样式 */
@media print {
  .pdf-wrapper {
    display: none !important;
  }
  body::after {
    content: '本内容禁止打印';
    font-size: 24px;
    text-align: center;
    display: block;
    margin-top: 50px;
  }
}

.error-tip {
  color: #f56c6c;
  text-align: center;
  padding: 20px;
  font-size: 16px;
}

/* 隐藏图片的右键菜单相关样式 */
::-webkit-media-controls-enclosure {
  display: none !important;
}

@media screen and (max-width: 1000px) {
  .pdf-image-container {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
  }
  /* 移动端水印适配 */
  .watermark-text {
    font-size: 32px;
    letter-spacing: 6px;
  }
}
@media print {
  .pdf-wrapper {
    display: none !important;
  }
  
  body {
    visibility: hidden !important;
  }
  
  body::after {
    content: '本内容禁止打印' !important;
    visibility: visible !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    font-size: 24px !important;
    color: #000 !important;
    background: white !important;
    padding: 20px !important;
    border: 2px solid #f00 !important;
    z-index: 999999 !important;
  }
}

/* 反截图保护 */
.pdf-wrapper {
  /* 增加反截图伪影 */
  position: relative;
  overflow: hidden;
}

.pdf-wrapper::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: transparent;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s;
}

/* 检测到开发者工具时的样式 */
.pdf-wrapper.dev-tools-open::after {
  background: rgba(255, 255, 255, 0.9);
  opacity: 1;
  content: '⚠️ 检测到开发者工具，已自动保护内容';
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #333;
}
</style>